import { toast } from 'react-toastify';
import UserService from '../services/UserService';
import { UserProfile, Location } from './UserStore';

export interface IUserApi {
  updateUserProfile(data: Partial<UserProfile>): Promise<UserProfile>;
  getUserProfile(): Promise<UserProfile>;
  contactUs(data: Record<string, unknown>): Promise<void>;
  getLocations(): Promise<Location[]>;
  getCurrencies(): Promise<string[]>;
}

export class UserApi implements IUserApi {
  async updateUserProfile(data: Partial<UserProfile>): Promise<UserProfile> {
    const response = await UserService.updateUserProfile(data);
    if (response?.status === 200) {
      toast.success('Profile updated successfully');
      return response.data;
    }
    throw new Error('Failed to update profile');
  }

  async getUserProfile(): Promise<UserProfile> {
    const response = await UserService.getUserProfile();
    if (response?.status === 200 && response.data) return response.data;
    throw new Error('Failed to fetch user profile');
  }

  async contactUs(data: Record<string, unknown>): Promise<void> {
    const response = await UserService.contactUs(data);
    if (response?.status !== 200) throw new Error('Failed to send message');
  }

  async getLocations(): Promise<Location[]> {
    const response = await UserService.getLocations();
    if (response?.status === 200 && response.data) return response.data;
    throw new Error('Failed to get locations');
  }

  async getCurrencies(): Promise<string[]> {
    const response = await UserService.getCurrencies();
    if (response?.status === 200 && response.data) return response.data;
    throw new Error('Failed to get currencies');
  }
}
